import { render, staticRenderFns } from "./ConfigStyle.vue?vue&type=template&id=41936d47&scoped=true&"
import script from "./ConfigStyle.vue?vue&type=script&lang=ts&"
export * from "./ConfigStyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41936d47",
  null
  
)

export default component.exports